export enum SortKey {
	RELEVANCE = 'RELEVANCE',
	DATE = 'DATE',
	CREATION_DATE = 'CREATION_DATE',
	ALPHABETICAL = 'ALPHABETICAL',
}
